
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hot-contracts",
      function () {
        return require("private-next-pages/hot-contracts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hot-contracts"])
      });
    }
  